var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.market
    ? _c(
        "v-container",
        { staticClass: "market-headline", attrs: { fluid: "" } },
        [
          _vm.iseventlive && _vm.market
            ? _c(
                "div",
                [
                  _c("markets", {
                    staticClass: "markets-container",
                    attrs: {
                      markets: [_vm.market],
                      diplayOnPage: "headline-market"
                    }
                  })
                ],
                1
              )
            : _c(
                "div",
                [_c("coupon-event", { attrs: { market: _vm.market } })],
                1
              )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ba12317c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ba12317c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/bettingoffer/headlineMarket.vue
// module id = null
// module chunks = 